import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./main/App";
import { AppFactory } from "main/app-factory";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from "dayjs";

dayjs.extend(customParseFormat);
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppFactory>

    </AppFactory>
  </React.StrictMode>
);
